import {isPlatformServer, NgOptimizedImage} from "@angular/common";
import {Component, inject, LOCALE_ID, PLATFORM_ID, signal} from "@angular/core";
import {RouterLink} from "@angular/router";

interface Language {
  readonly code: string;
  readonly name: string;
  readonly flag: {
    readonly source: string,
    readonly size: {
      readonly width: number,
      readonly height: number,
    },
  };
}

@Component({
  selector: "app-footer",
  templateUrl: "./footer.html",
  styleUrl: "./footer.scss",
  imports: [
    NgOptimizedImage,
    RouterLink,
  ],
})
export class Footer {
  private readonly platformId = inject(PLATFORM_ID);
  protected readonly locale = signal(inject(LOCALE_ID));
  protected readonly currentYear = new Date().getFullYear();
  protected readonly languages: readonly Language[] = [
    {
      code: "de", name: $localize`Deutsch`, flag: {
        source: "assets/images/flag-germany.svg",
        size: {width: 1000, height: 600},
      },
    },
    {
      code: "en", name: $localize`Englisch`, flag: {
        source: "assets/images/lang-english.svg",
        size: {width: 1300, height: 650},
      },
    },
  ];

  protected switchLanguage(language: Language): void {
    if (language.code === this.locale()) return;
    const oldLocale = this.locale();
    this.locale.set(language.code);
    if (isPlatformServer(this.platformId)) return;
    window.location.href = window.location.href.replace(new RegExp(`/${oldLocale}/(.*)$`, "u"), `/${language.code}/$1`);
  }
}
